var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-taglist',_vm._l((_vm.screen_sets),function(set){return _c('div',[_c('b-tag',[_vm._v(_vm._s(set.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }